import { BoardSummary, CardAssociations, LabelReference, ListReference, MemberReference, StageReference } from 'app/trello/models/board-summary';
import { BoardSummaryFilter } from 'app/trello/workers/pure-services/board-summary-filter';
import isEqual from 'lodash-es/isEqual';

export class BoardSummaryMapper {

  constructor(
    private readonly boardSummaryFilter: BoardSummaryFilter,
  ) {
  }

  public map(
    boardSummary: BoardSummary,
  ): BoardSummary {

    const x = JSON.stringify(boardSummary.labels, null, 2);

    if (!boardSummary.cards) {
      return boardSummary;
    }

    const logMessage = 'BoardSummaryMapper (' + Object.keys(boardSummary.cards).length + ' cards)';

    console.time(logMessage);

    const boardStats = boardSummary.board;

    const cardsByLabelId = this.invertMapping(boardSummary.cards, 'labels');
    const cardsByListId = this.invertMapping(boardSummary.cards, 'lists');
    const cardsByMemberId = this.invertMapping(boardSummary.cards, 'members');
    const cardsByStage = this.invertMapping(boardSummary.cards, 'stages');

    // if (boardSummary.board.label.duration['2025-02-24']) {
    //   console.log('cardsByLabelId', cardsByLabelId['66feacbdcfe89b3b8450e4d0']);
    //   console.log('boardSummary.board.label', boardSummary.board.label.duration['2025-02-24']['67bc692817f61c9aac0a4fe5']);
    // }

    const statsForLabels = Object.fromEntries(
      Object.entries(cardsByLabelId).map(([labelId, cardIds]) => [
          labelId,
          this.boardSummaryFilter.filter(boardSummary.board, new Set(cardIds)),
        ]
      )
    );

    const statsForLists = Object.fromEntries(
      Object.entries(cardsByListId).map(([listId, cardIds]) => [
          listId,
          this.boardSummaryFilter.filter(boardSummary.board, new Set(cardIds)),
        ]
      )
    );

    const statsForMembers = Object.fromEntries(
      Object.entries(cardsByMemberId).map(([memberId, cardIds]) => [
          memberId,
          this.boardSummaryFilter.filter(boardSummary.board, new Set(cardIds)),
        ]
      )
    );

    const statsForStages = Object.fromEntries(
      Object.entries(cardsByStage).map(([stage, cardIds]) => [
          stage,
          this.boardSummaryFilter.filter(boardSummary.board, new Set(cardIds)),
        ]
      )
    );

    console.timeEnd(logMessage);

    if (!isEqual(boardSummary.labels, statsForLabels)) {
      console.log('labels unequal!');
      console.log('boardSummary.labels', x);
      console.log('statsForLabels', JSON.stringify(statsForLabels, null, 2));
    }

    return {
      ...boardSummary,
      board: boardStats,
      labels: statsForLabels,
      lists: statsForLists,
      members: statsForMembers,
      stages: statsForStages,
    };
  }

  private invertMapping(
    cards: Record<string, CardAssociations>,
    key: keyof CardAssociations,
  ): { [id: string]: string[] } {

    const result: { [id: string]: string[] } = {};

    for (const [cardId, associations] of Object.entries(cards)) {

      for (const reference of associations[key]) {

        const id = this.idFromReference(reference);

        if (!(id in result)) {
          result[id] = [];
        }

        result[id].push(cardId);
      }
    }

    return result;
  }

  private idFromReference(
    reference: LabelReference | ListReference | MemberReference | StageReference,
  ): string {

    if ('labelId' in reference) {
      return reference.labelId;

    } else if ('listId' in reference) {
      return reference.listId;

    } else if ('memberId' in reference) {
      return reference.memberId;

    } else if ('stage' in reference) {
      return reference.stage;

    } else {
      throw new Error('Cannot extract id from reference: ' + JSON.stringify(reference));
    }
  }

}
